__turbopack_context__.v({
  "active": "promotions-list-module-sass-module__4S-YMq__active",
  "promotionBanner": "promotions-list-module-sass-module__4S-YMq__promotionBanner",
  "promotionBannerIcon": "promotions-list-module-sass-module__4S-YMq__promotionBannerIcon",
  "promotionBannerLabel": "promotions-list-module-sass-module__4S-YMq__promotionBannerLabel",
  "promotionBannerTxt": "promotions-list-module-sass-module__4S-YMq__promotionBannerTxt",
  "selected": "promotions-list-module-sass-module__4S-YMq__selected",
});
